import {MetaTitleDesc} from "./../meta";
import DocumentMeta from "react-document-meta";

export default () => {
    const title = 'Комплексный пункт придорожного сервиса';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    <h3>Post of service on a highway</h3>

                    <h4>А. Описание возможностей проекта</h4>
                    <p>А1 Название проекта: <strong>Комплексный пункт придорожного сервиса</strong></p>
                    <p>(а) Краткое название: Комплексный пункт придорожного сервиса</p>
                    <p>(b) Полное название: Комплексный пункт придорожного сервиса</p>
                    <p>(c) Краткое описание (аннотация). Комплексный пункт придорожною сервиса на км. 167,5 (лево) автомобильной дороги М1/Е 30 Брест (Козловичи)-Минск-граница Российской Федерации (Редьки).</p>
                    <p>А2 Состояние проекта: Национальной программой развития туризма в Республике Беларусь на 2006-2010 гг. утвержденной Советом Министров Республики Беларусь 23.08.2005 г. предусмотрено в разделе «мероприятия» к решению облисполкома от 21.11.05 развитие транзитного туризма (п. 2.3.) проектирование и строительство комплексного пункта придорожного сервиса на 167,5 км автотрассы М 1/Е 30. Срок исполнения - 2010 год. Ответственные исполнители: Ивацевичский райисполком и ЧУП «ВЛИВСК-Сайн». Источник финансирования - собственные средства.</p>
                    <p>А3 Участвующие организации и их роль (контактные лица, телефон, факс, е-mail, страница в Интернет</p>
                    <ol>
                        <li>Ивацевичский райисполком и ЧУП «ВЛИВСК-Сайн». Контактное лицо от ЧУП «ВЛИВСК-Сайн» - Иванов Сергей Валерьевич. </li>
                    </ol>
                    <p>А4 Описание проекта (подходы, задачи, компоненты, результаты, этапы, сроки, общее финансирование, преимущества, влияние на переходные процессы в экономике и т.д.)</p>
                    <p>Общим подходом определяется развитие транзитно - туристической зоны «Брест-Барановичи-граница области» и развитие инфраструктуры туризма вдоль международного транспортного коридора № 2 Париж-Берлин-Варшава-Брест-Минск-Москва» В настоящее время проект выполнен в рамках эскизного решения и технологической части.</p>
                    <p>А5 Предпосылки (история, общая программа, взаимосвязанные или схожие проекты)</p>
                    <p>Приоритет в развитии въездного туризма, налоговые льготы </p>
                    <p>А8 Срок реализации и окупаемости проекта (лет): 4 года</p>

                    <h4>В. Статьи капитальных затрат (суммарные инвестиции, необходимые для реализации проекта):</h4>
                    <p>В1 Физические компоненты проекта (оборудование, работы, услуги и др. необходимые для реализации проекта): собственные средства</p>
                    <p>B2 Капиталовложения (стоимость): собственные средства</p>
                    <p>Итого (должна равняться сумме С2+D4)</p>

                    <h4>С. Капитал по источнику происхождения, имеющейся в наличии инициаторов проекта (собственников, соучастников, спонсоров и т.п.)</h4>
                    <p>Нет.</p>

                    <h4>D. Требуемые инвестиции, недостающие средства</h4>
                    <p>-</p>

                    <h4>Е. Спрос (потребители) и доходы</h4>
                    <p>-</p>

                    <h4>F. Операционные и эксплуатационные расходы</h4>
                    <p>-</p>

                    <h4>G. Чистый доход</h4>
                    <p>-</p>

                    <h4>Н. Источник информации о проекте</h4>
                    <p>Н1 Форма заполнения (кем, Ф.И.О., должность): Иванов Сергей Валерьевич</p>
                    <p>Н2 Организация (наименование и адрес): Ивацевичский райисполком и ЧУП «ВЛИВСК-Сайн»</p>
                    <p>Н5 Ведомственная принадлежность проекта: Министерство спорта и туризма </p>
                </div>
            </div>
        </>
    );
}